/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidSubmissionsControllerListQueryResponse, BidSubmissionsControllerListQueryParams, BidSubmissionsControllerList401, BidSubmissionsControllerList403 } from "../../models/bidsController/BidSubmissionsControllerList";

function getBidSubmissionsControllerListUrl() {
  const res = { method: 'GET', url: `/api/v1/bid-submissions` as const }  
  return res
}

/**
 * @summary List a trade's bids and replies, newest first
 * {@link /api/v1/bid-submissions}
 */
export async function bidSubmissionsControllerList(params: BidSubmissionsControllerListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidSubmissionsControllerListQueryResponse, ResponseErrorConfig<BidSubmissionsControllerList401 | BidSubmissionsControllerList403>, unknown>({ method : "GET", url : getBidSubmissionsControllerListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}